import React, { useState } from 'react';
import axios from 'axios';
import { handlePrint } from '../api/printUtils.js';
import toast from 'react-hot-toast';

const API_URL = process.env.REACT_APP_API_URL;

const PrintToOfficeModal = ({ isOpen, docno, finyear, doctype, headers, onClose }) => {
  const [copies, setCopies] = useState(1);
  const [isPrinting, setIsPrinting] = useState(false);

  const handleConfirmPrint = async () => {
    if (!copies || isNaN(copies) || copies <= 0) {
  toast.error("Please enter a valid number of copies.");
  return;
}

    setIsPrinting(true);
    try {
      // open the new tab only now (after user confirmed)
      const pdfWindow = window.open('', '_blank');
      if (!pdfWindow) {
        toast.error("Pop-up blocked! Please allow pop-ups for this site.");
        return;
      }
      pdfWindow.document.body.innerHTML = `
        <style>
          body { display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;background:#f0f0f0; }
          .loader { border:8px solid #e0e0e0; border-top:8px solid #3498db; border-radius:50%; width:60px; height:60px; animation: spin 1s linear infinite; }
          @keyframes spin {0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}
        </style>
        <div>
          <div class="loader"></div>
          <span>Generating document...</span>
        </div>
      `;

      const localPrintPromise = handlePrint(docno, finyear, doctype, pdfWindow);
      const officePrintPromise = axios.post(
        `${API_URL}/document/physical-print/${docno}/${finyear}?doctype=${doctype}&copies=${copies}`,
        null,
        { headers }
      );

      const [, officeResult] = await Promise.allSettled([localPrintPromise, officePrintPromise]);

      if (officeResult.status === "rejected") {
        const detail = officeResult.reason.response?.data?.detail || "Could not connect to office printer.";
        toast.error(`PDF opened locally, but failed to print at the office: ${detail}`);
      } else {
        toast.success(`PDF opened locally and sent to the office printer (${copies} copies)!`);
      }
    } catch (err) {
      console.error("Print error:", err);
      toast.error("An unexpected error occurred.");
    } finally {
      setIsPrinting(false);
      onClose();
    }
  };
  const handleCancel = () => {
    // ✅ On cancel, call onClose with a failure/cancel status
    onClose();
  };
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Print to Office</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="copiesInput">Number of Copies</label>
            <input
                id="copiesInput"
                type="number"
                value={copies}
                onChange={e => {
                    const val = e.target.value;
                    setCopies(val === "" ? "" : parseInt(val, 10));
                }}
                min="1"
                autoFocus
                onKeyDown={e => e.key === 'Enter' && handleConfirmPrint()}
                />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose} disabled={isPrinting}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleConfirmPrint} disabled={isPrinting}>
            {isPrinting ? "Printing..." : "Confirm & Print"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrintToOfficeModal;
